import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
const offers = [{
  title: 'El Protocolo SOS Nervio Ciático (Guía Paso a Paso)',
  description: 'El plan exacto de 14 días para pasar de la agonía al alivio total.',
  isBonus: false
}, {
  title: 'Técnica de la Esfinge de 4 Minutos',
  description: 'La posición secreta para liberar el nervio instantáneamente.',
  isBonus: false
}, {
  title: 'Protocolo de Sueño Sin Dolor',
  description: 'Cómo usar tus almohadas para alinear tu pelvis y dormir 8 horas seguidas.',
  isBonus: false
}, {
  title: 'Plan de Blindaje Lumbar',
  description: 'Cómo entrar al auto y cargar peso sin disparar el dolor otra vez.',
  isBonus: false
}, {
  title: 'Lista de compras "SOS" en Walmart/Amazon',
  description: 'Los soportes y suplementos que sí funcionan (sin gastar en estafas).',
  isBonus: true
}];
export function OfferStack() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-102">
      <div className="max-w-3xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-104">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-charcoal" data-id="element-105">
            Todo lo que recibes hoy:
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-106">
          {offers.map((offer, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white p-6 rounded-xl shadow-sm border ${offer.isBonus ? 'border-orange/50 ring-1 ring-orange/20' : 'border-gray-100'} flex items-start relative overflow-hidden`} data-id="element-107">
              {offer.isBonus && <div className="absolute top-0 right-0 bg-orange text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-108">
                  Bono Especial
                </div>}

              <CheckCircle className={`w-6 h-6 flex-shrink-0 mr-4 mt-1 ${offer.isBonus ? 'text-orange' : 'text-green'}`} data-id="element-109" />

              <div data-id="element-110">
                <h3 className="font-heading font-bold text-xl text-charcoal mb-2 pr-20 md:pr-0" data-id="element-111">
                  {offer.isBonus ? <span className="text-orange mr-2" data-id="element-112">BONO:</span> : null}
                  {offer.title}
                </h3>
                <p className="font-body text-warm-gray" data-id="element-113">{offer.description}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="mt-12" data-id="element-114">
          <CTAButton href="#pricing-section" data-id="element-115" />
        </motion.div>
      </div>
    </section>;
}